<template>
<div class="chapter">
<div class="inner_page">
<p class="P_RaggedRight" id="auto_bookmark_toc_1"><span style=" font-weight: bold; font-size: 1.17em;">Beau shifted the two covered dishes to one arm and rang the doorbell. For a moment he heard nothing; then a muffled voice—probably Jake’s—called out, “I’m coming!” Another thirty seconds passed before the door opened, and Jake stood there, his hair damp and tousled, feet bare and a button-down shirt hanging open over his chest. If there was a better sight than Jake Parnell fresh out of the shower, Beau didn’t know what it was. Even his new grill couldn’t compete with Jake’s flushed skin and lightly furred chest. He couldn’t help but notice the treasure trail leading into Jake’s low-riding jeans, but he quickly snapped his gaze back up to Jake’s face.</span></p>
<p class="P_RaggedRight"> </p>
<p class="P_RaggedRight">“I brought dinner,” he said after clearing his throat. “I figured you wouldn’t wanna cook between the competition and the Pantry, and your mama’s got enough to do.”</p>
<p class="P_RaggedRight"> </p>
<p class="P_RaggedRight">Jake looked nonplussed for a moment, but then he stepped back from the door. “Thank you. Please come inside.”</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// section0001.vue?1e697cb2